import { render, staticRenderFns } from "./VerificationWrapper.vue?vue&type=template&id=14b3b413"
import script from "./VerificationWrapper.vue?vue&type=script&lang=js"
export * from "./VerificationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports